<div class="container" [ngSwitch]="mode">
  <div *ngSwitchCase="'form'">
    <app-template [title]="'Result Entry'">
      <div class="info">
        <div class="single">
          <div>
            <p>
              Name. : <b>{{ patient[0]?.first_name }}</b>
            </p>
            <p>
              Sex. : <b>{{ patient[0]?.sex }}</b>
            </p>
            <p>
              Age. : <b>{{ patient[0]?.age }}</b>
            </p>
            <p>
              Mobile : <b>{{ patient[0]?.mobile }}</b>
            </p>
          </div>
        </div>
        <span *ngIf="!isSelected">
          <button
            *ngIf="!isSaveLoading"
            [disabled]="stateForm.invalid"
            (click)="Submit(e)"
            mat-raised-button
            color="primary"
          >
            Send
          </button>
          <button
            *ngIf="isSaveLoading"
            [disabled]="stateForm.invalid"
            (click)="Submit(e)"
            mat-raised-button
            color="primary"
          >
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </button>
        </span>
        <span *ngIf="isSelected">
          <button
            *ngIf="!isSaveLoading"
            [disabled]="stateForm.invalid"
            (click)="Submit(e)"
            mat-raised-button
            color="primary"
          >
            Save
          </button>
          <button
            *ngIf="isSaveLoading"
            [disabled]="stateForm.invalid"
            (click)="Submit(e)"
            mat-raised-button
            color="primary"
          >
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </button>
          <button
            (click)="backs()"
            mat-raised-button
            color="primary"
            style="margin-left: 20px"
          >
            Back
          </button>
        </span>
      </div>
      <div class="data">
        <div *ngIf="isLoading" style="margin-top: 50px" class="spinner">
          <mat-spinner></mat-spinner>
        </div>
        <table *ngIf="!isLoading" style="width: 100%">
          <tr class="back">
            <th>Date</th>
            <th>Dept</th>
            <th>Verified</th>
            <th>Typed</th>
            <th>Service Name</th>
            <th>Finalized?</th>
            <th>Printed?</th>
            <th>Online?</th>
            <th></th>
          </tr>
          <tr class="td" *ngFor="let item of tableData" style="cursor: pointer">
            <td>
              {{ item.result_date | date }}<br />
              <b>{{ item.result_time }}</b>
            </td>
            <td>{{ item.department_name }}</td>
            <td>
              <p *ngIf="!item.is_verified">No</p>
              <img
                *ngIf="item.is_verified"
                style="width: 30px; height: 30px"
                src="assets/icons/done.gif"
                alt=""
              />
            </td>
            <td>
              <img
                *ngIf="item.result_saved === 'Y'"
                style="width: 30px; height: 30px"
                src="assets/icons/done.gif"
                alt=""
              />
            </td>
            <td>{{ item.service_name }}</td>
            <td>
              <img
                *ngIf="item.is_finalized === 'Y'"
                style="width: 30px; height: 30px"
                src="assets/icons/done.gif"
                alt=""
              />
            </td>
            <!-- <td>{{ item.is_finalized }}</td> -->

            <td>
              <img
                *ngIf="item.printed === 'Y'"
                style="width: 30px; height: 30px"
                src="assets/icons/done.gif"
                alt=""
              />
            </td>
            <td>
              <img
                *ngIf="item?.pushedOnlineStatus !== null"
                style="width: 30px; height: 30px"
                src="assets/icons/done.gif"
                alt=""
              />
            </td>
            <td>
              <div class="dropdown">
                <button class="dropbtn" mat-raised-button>Actions</button>
                <div class="dropdown-content">
                  <a class="dropdown-item" (click)="addRecord(item)"
                    >View Record</a
                  >
                  <!-- <a
                    *ngIf="
                      item.pushedOnlineStatus == null &&
                      item.is_finalized == 'Y'
                    "
                    class="dropdown-item"
                    (click)="pushOnline(item)"
                    >Push Online</a
                  > -->
                  <!-- <a class="dropdown-item" (click)="pushOnline(item)"
                    >Push Online</a
                  > -->
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </app-template>
  </div>
  <div class="wizwig" *ngSwitchCase="'wiz'">
    <app-template [title]="'Format Result'">
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Template</mat-label>
            <mat-select matNativeControl required>
              <mat-option *ngIf="isLoading">Loading Data</mat-option>
              <mat-option
                *ngFor="let template of templates"
                (click)="setTemplate(template)"
                [value]="template.Id"
              >
                {{ template.Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <div
          id="print-section"
          style="display: none; width: 500px; margin: auto"
          [innerHTML]="Template_Text"
        ></div>
        <div class="space"></div>
        <angular-editor
          [config]="editorConfig"
          [placeholder]="'Enter text here...'"
          [(ngModel)]="Template_Text"
        ></angular-editor>
        <!-- <quill-editor [(ngModel)]="Template_Text" [styles]="{height: '300px'}"></quill-editor> -->

        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
            <p>{{ Errors }}</p>
          </div>
        </div>
        <button
          (click)="back()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Back
        </button>
        <button
          class="create"
          mat-raised-button
          color="primary"
          [matMenuTriggerFor]="menu"
        >
          More
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="done()">Done</button>
          <button
            mat-menu-item
            *ngIf="!verifyLoad"
            (click)="updateIsVerifeid()"
          >
            Verify
          </button>
          <button mat-menu-item *ngIf="verifyLoad" (click)="updateIsVerifeid()">
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </button>
          <button mat-menu-item (click)="SendReview()">Send For Review</button>
          <button mat-menu-item *ngIf="!statusLoad" (click)="status()">
            Status
          </button>
          <button mat-menu-item *ngIf="statusLoad">
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </button>
        </mat-menu>
        <!-- <button *ngIf="verifyLoad" class="create" mat-raised-button color="primary"> <i class="fa fa-spinner fa-spin" aria-hidden="true"></i></button>
                <button (click)="SendReview()" class="create" mat-raised-button color="primary">
                  Send For Review
                </button>
                <button *ngIf="!statusLoad" (click)="status()" class="create" mat-raised-button color="primary">
                  Status
                </button>
                <button *ngIf="statusLoad" class="create" mat-raised-button color="primary"> </button>

                <button (click)="pushOnline()" class="create" mat-raised-button color="primary">
                  Push Online
                </button>

                <button (click)="done()" class="create" mat-raised-button color="primary">
                    Done
                </button> -->
        <div class="space"></div>
      </div>
    </app-template>
  </div>
</div>
